import { ModuleTranslationProvider } from '../../../contexts/ModuleTranslation'

import translations from './locales'
import useCart from '../../../hooks/useCart'
import LivingWellCompanion from './LivingWellCompanion'
import { getLWCService, shouldRender } from './utils'
import { isHSExistingCustomer } from '../../../utils/cart'
import useFeatureFlags from '../../../hooks/useFeatureFlags'

// Living Well Companion (LWC)
const LWCContainer = () => {
  const { cart } = useCart()
  const { data: featureFlags } = useFeatureFlags()
  if (!shouldRender(cart, featureFlags)) return null
  const lwcService = getLWCService(cart)

  return (
    <ModuleTranslationProvider translations={translations} module="living-well-companion">
      <LivingWellCompanion
        lwcService={lwcService}
        cart={cart}
        featureFlags={featureFlags}
        isRemoveButtonHidden={isHSExistingCustomer(cart)}
      />
    </ModuleTranslationProvider>
  )
}

export default LWCContainer
